import { AccountResolverService } from "@gtmhub/state/accountResolverService";
import { Component, OnInit } from "@angular/core";
import { localize } from "@gtmhub/localization";

@Component({
  selector: "reports-and-notifications",
  templateUrl: "./reports-and-notifications.component.html",
  styleUrls: ["./reports-and-notifications.component.less"],
})
export class ReportsAndNotificationsComponent implements OnInit {
  public accountNotificationsCadenceType: string;

  constructor(private accountResolverService: AccountResolverService) {}

  public ngOnInit(): void {
    this.accountNotificationsCadenceType = this.formatAccountNotificationsCadence();
  }

  // Remove notificationsCadenceType from AJS once we release the feature since this is the only place
  // the logic that the filter handles should be used, therefore it is more appropriate to be in the controls' logic
  private formatAccountNotificationsCadence(): string {
    const account = this.accountResolverService.getAccountData();
    switch (account.notifications.cadence) {
      case "Daily":
        return localize("daily");
      case "Weekly":
        return localize("weekly");
      case "Monthly":
        return localize("monthly");
      case "BiWeekly":
        return localize("every_two_weeks");
    }
  }
}
